import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Backdrop,
  CircularProgress,
  DialogActions,
} from "@mui/material";
import styled from "styled-components";
import api from "../../api/config";
import { useNotification } from "../../context/NotificationContext";
import TableWithPagination from "./TableWithPagination";
import { PostClientAccess } from "../../api/Client";

const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  background-color: #2b3342;
  color: white;
`;

const Footer = styled(DialogActions)`
  background-color: #28929c;
  padding: 10px;
`;

export default function ClientAccessModal({
  open,
  onClose,
  onSaveSuccess = () => {},
  isEdit = false,
  selectedAccessLevel = {},
  selectedClient = {},
  modalLoading = false,
}) {
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();
  const [selectedRows, setSelectedRows] = useState([]);
  const permissionsColumns = [{ id: "form", label: "Name" }];
  const permissionsTableData = [
    {
      id: 1,
      form: "Requests",
      name: "addRequest",
    },
    {
      id: 2,
      form: "Send Patient Chart",
      name: "sendPatientChart",
    },
    {
      id: 3,
      form: "View Files",
      name: "viewFiles",
    },
    {
      id: 4,
      form: "Upload Files",
      name: "uploadFiles",
    },
    {
      id: 5,
      form: "Digital Fax",
      name: "digitalFax",
    },
    {
      id: 6,
      form: "Share Patient Chart",
      name: "sharePatientChart",
    },
    {
      id: 7,
      form: "De_Identification Module",
      name: "deidentificationModule",
    },
    {
      id: 8,
      form: "Insurance Eligbility",
      name: "insuranceEligbility",
    },

    {
      id: 9,
      form: "Patient360",
      name: "patient360",
    },
    {
      id: 10,
      form: "Form Builder",
      name: "formBuilder",
    },
    {
      id: 11,
      form: "Delete Patient",
      name: "deletePatient",
    },
    {
      id: 12,
      form: "aibot",
      name: "aibot",
    },
    {
      id: 13,
      form: "Dashboard",
      name: "dashboard",
    },
    {
      id: 14,
      form: "Dashboard Extension",
      name: "dashboardExtension",
    },
    {
      id: 15,
      form: "Billing",
      name: "billing",
    },
    {
      id: 16,
      form: "Access Level Settings",
      name: "accessLevelSettings",
    },
    {
      id: 17,
      form: "My Images",
      name: "myimages",
    },
    {
      id: 18,
      form: "Add New Tenant",
      name: "addNewTenant",
    },
    {
      id: 19,
      form: "Update Tenant",
      name: "updateTenant",
    },
    {
      id: 20,
      form: "Access Other Tenants",
      name: "accessOtherTenants",
    },
    {
      id: 21,
      form: "AllAudit Logs",
      name: "allAuditLogs",
    },
  ];

  useEffect(() => {
    setLoading(modalLoading);
  }, [modalLoading]);

  useEffect(() => {
    if (!open) return;

    setSelectedRows([]);

    if (isEdit && selectedAccessLevel) {
      const activePermissions = permissionsTableData.filter(
        (item) => selectedAccessLevel[item.name] === true
      );
      setSelectedRows(activePermissions);
    } else {
      setSelectedRows([]);
    }
  }, [open, isEdit, selectedAccessLevel]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const permissions = permissionsTableData.reduce((acc, item) => {
        acc[item.name] = selectedRows.some(
          (selected) => selected.id === item.id
        );
        return acc;
      }, {});

      const filteredPermissions = {
        clientUID: selectedAccessLevel.clientUID,
        ...Object.fromEntries(
          Object.entries(permissions).filter(([key, value]) => value === true)
        ),
      };

      await api.post(
        `${PostClientAccess}/${selectedAccessLevel.clientUID}?clientUID=${selectedAccessLevel.clientUID}`,
        filteredPermissions
      );
      showNotification("Client Access Updated", "success");
      onSaveSuccess();
      handleClose();
    } catch (error) {
      console.error("Error updating access level:", error);
      showNotification("Error updating access level", "error");
    }
    setLoading(false);
  };

  const handleClose = () => {
    setSelectedRows([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Header>Access Level for {selectedClient?.npi_name || ""}</Header>

      <Content>
        <TableWithPagination
          title="Access Level Permissions"
          columns={permissionsColumns}
          rows={permissionsTableData}
          noSearch
          selectableRows
          preSelectedRows={selectedRows}
          onSelectedRowsChange={(rows) => {
            setSelectedRows(rows);
            console.log("Selected Rows:", rows);
          }}
          height="450px"
          totalRecords={permissionsTableData.length}
          page={0}
          limit={permissionsTableData.length}
        />
      </Content>

      <Footer>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          {isEdit ? "Update Access Level" : "Save Access Level"}
        </Button>
      </Footer>

      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
